<template>
    <div v-loading="drawerTableLoading" style="height: 100%; display: flex; flex-direction: column;" :class="type == 'DHD' || type == 'ZZD' ? 'special_drawer': ''">
        <el-card shadow="never" class="detail_drawer_card" style="border: none;">
            <template v-if="type == 'XSD' || type == 'XST'">
                <el-row>
                    <el-col :span="8"><label>客户:</label><span>{{ detailDrawerHeader.customerName }}</span></el-col>
                    <el-col :span="8"><label>业务员:</label><span>{{ detailDrawerHeader.salesmanName }}</span></el-col>
                    <el-col :span="8"><label>仓库:</label><span>{{ detailDrawerHeader.warehouseName }}</span></el-col>
                </el-row>
                <el-row>
                    <el-col :span="8"><label>单号:</label><span>{{ detailDrawerHeader.billNo }}</span></el-col>
                    <el-col :span="8"><label>合计数量:</label><span>{{ detailDrawerHeader.billQty }}</span></el-col>
                    <el-col :span="8" v-if="orderType != 'CHD'"><label>合计金额:</label><span>{{ detailDrawerHeader.totalAmt }}</span></el-col>
                    <el-col :span="8" v-else><label>备注:</label><span>{{ detailDrawerHeader.remark }}</span></el-col>
                </el-row>
                <el-row v-if="orderType == null">
                    <el-col :span="8"><label>收款信息:</label><span>{{ detailDrawerHeader.collectionInfo }}</span></el-col>
                    <el-col :span="16"><label>备注:</label><span>{{ detailDrawerHeader.remark }}</span></el-col>
                </el-row>
                <el-row v-else-if="orderType == 'HHD'">
                    <el-col :span="16"><label>备注:</label><span>{{ detailDrawerHeader.remark }}</span></el-col>
                </el-row>
            </template>
            <template v-else-if="type == 'DHD' || type == 'ZZD'">
                <el-row>
                    <el-col :span="8"><label>客户:</label><span>{{ detailDrawerHeader.customerName }}</span></el-col>
                    <el-col :span="8"><label>业务员:</label><span>{{ detailDrawerHeader.salesmanName }}</span></el-col>
                    <el-col :span="8"><label>订货会:</label><span>{{ detailDrawerHeader.salOrderMeetName }}</span></el-col>
                </el-row>
                <el-row>
                    <el-col :span="8"><label>合计金额:</label><span>{{ detailDrawerHeader.totalAmt }}</span></el-col>
                    <el-col :span="8"><label>收款金额:</label><span>{{ detailDrawerHeader.payAmt }}</span></el-col>
                    <el-col :span="8"><label>折扣金额:</label><span>{{ detailDrawerHeader.discountAmt }}</span></el-col>
                </el-row>
                <el-row>
                    <el-col :span="8"><label>新增欠款:</label><span>{{ detailDrawerHeader.arrearAmt }}</span></el-col>
                    <el-col :span="8"><label>冲抵预收:</label><span>{{ detailDrawerHeader.prePayAmt }}</span></el-col>
                    <el-col :span="8"><label>状态:</label><span>{{ detailDrawerHeader.billStatusStr }}</span></el-col>
                </el-row>
                <el-row>
                    <el-col :span="16"><label>备注:</label><span>{{ detailDrawerHeader.remark }}</span></el-col>
                </el-row>
            </template>
            <template v-else-if="type == 'XSY' || type == 'XTY'">
                <el-row>
                    <el-col :span="8"><label>客户:</label><span>{{ detailDrawerHeader.customerName }}</span></el-col>
                    <el-col :span="8"><label>业务员:</label><span>{{ detailDrawerHeader.salesmanName }}</span></el-col>
                    <el-col :span="8"><label>仓库:</label><span>{{ detailDrawerHeader.warehouseName }}</span></el-col>
                </el-row>
                <el-row>
                    <el-col :span="8"><label>单号:</label><span>{{ detailDrawerHeader.billNo }}</span></el-col>
                    <el-col :span="8"><label>合计数量:</label><span>{{ detailDrawerHeader.billQty }}</span></el-col>
                    <el-col :span="8"><label>合计金额:</label><span>{{ detailDrawerHeader.totalAmt }}</span></el-col>
                </el-row>
                <el-row>
                    <el-col :span="16"><label>备注:</label><span>{{ detailDrawerHeader.remark }}</span></el-col>
                </el-row>
            </template>
        </el-card>
        <div class="detail_drawer_table">
            <el-table :data="detailDrawerTable" border stripe height="100%" max-height="100%">
                <template v-if="orderMeetType">
                    <el-table-column type="index" width="30"></el-table-column>
                    <el-table-column label="品牌名称" prop="brandName"></el-table-column>
                    <el-table-column label="总金额" prop="totalAmt"></el-table-column>
                    <el-table-column label="备注" prop="remark"></el-table-column>
                </template>
                <template v-else>
                    <el-table-column type="index" width="50" align="center"></el-table-column>
                    <el-table-column label="商品" min-width="140px" prop="itemName"></el-table-column>
                    <el-table-column label="规格" prop="itemSpec" width="60"></el-table-column>
                    <el-table-column label="销售形式" prop="isLargessFormat" width="70"></el-table-column>
                    <el-table-column label="数量" prop="billQty" width="100">
                        <template slot-scope="scope">
                            <span v-show="scope.row.salUnitName">
                                <span>{{ Number((Number(scope.row.salUnitQty) || 0).toFixedRoundUp(2)) }}</span>
                                <span>{{ scope.row.salUnitName }}</span>
                            </span>
                            <span v-show="scope.row.midUnitName">
                                <span>{{ Number((Number(scope.row.midUnitQty) || 0).toFixedRoundUp(2)) }}</span>
                                <span>{{ scope.row.midUnitName }}</span>
                            </span>
                            <span v-show="scope.row.salUnitConversion != 1 && scope.row.invUnitName">
                                <span>{{ Number((Number(scope.row.invUnitQty) || 0).toFixedRoundUp(2)) }}</span>
                                <span>{{ scope.row.invUnitName }}</span>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="小单位数量" prop="invQty" width="84"></el-table-column>
                    <el-table-column label="配送数量" prop="consignQtyStr" width="66" v-if="type == 'XSY'">
                        <template slot-scope="scope">
                            <span v-show="scope.row.salUnitName">
                                <span>{{ Number((Number(scope.row.consignSalUnitQty) || 0).toFixedRoundUp(2)) }}</span>
                                <span>{{ scope.row.salUnitName }}</span>
                            </span>
                            <span v-show="scope.row.midUnitName">
                                <span>{{ Number((Number(scope.row.consignMidUnitQty) || 0).toFixedRoundUp(2)) }}</span>
                                <span>{{ scope.row.midUnitName }}</span>
                            </span>
                            <span v-show="scope.row.salUnitConversion != 1 && scope.row.invUnitName">
                                <span>{{ Number((Number(scope.row.consignInvUnitQty) || 0).toFixedRoundUp(2)) }}</span>
                                <span>{{ scope.row.invUnitName }}</span>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="单价" prop="billPrice" min-width="90px">
                        <template slot-scope="scope">
                            <p v-show="scope.row.salUnitName">
                                <span>{{ Number(Number(scope.row.salUnitPrice || 0).toFixedRoundUp(4)) }}/{{ scope.row.salUnitName }}</span>
                                <span></span>
                            </p>
                            <p v-show="scope.row.midUnitName">
                                <span>{{ Number((Number(scope.row.midUnitPrice) || 0).toFixedRoundUp(4)) }}/{{ scope.row.midUnitName }}</span>
                                <span></span>
                            </p>
                            <p v-show="scope.row.salUnitConversion != 1 && scope.row.invUnitName">
                                <span>{{ Number((Number(scope.row.invUnitPrice) || 0).toFixedRoundUp(4)) }}/{{ scope.row.invUnitName }}</span>
                                <span></span>
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column label="总金额" prop="totalAmt" width="80"></el-table-column>
                    <el-table-column label="生产日期" prop="productionDate" width="100" v-if="type != 'DHD' || type != 'ZZD'"></el-table-column>
                    <el-table-column label="条码" prop="billQty" width="142" v-if="type != 'DHD' || type != 'ZZD'">
                        <template slot-scope="scope">
                            <div v-if="scope.row.salBarCode">
                                <span>{{ scope.row.salBarCode }}</span><span>/大</span>
                            </div>
                            <div v-if="scope.row.midBarCode">
                                <span>{{ scope.row.midBarCode }}</span><span>/中</span>
                            </div>
                            <div v-if="scope.row.invBarCode">
                                <span>{{ scope.row.invBarCode }}</span><span>/小</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="口味名称" prop="flavorDesc" v-if="type != 'DHD' || type != 'ZZD'">
                    </el-table-column>
                    <el-table-column label="口味条码" prop="flavorBarCode" width="142" v-if="type != 'DHD' || type != 'ZZD'">
                    </el-table-column>
                    <el-table-column label="备注" prop="remark" min-width="140px"></el-table-column>
                </template>
            </el-table>
        </div>
    </div>
</template>
<script>
import { toFixedRe, debounce } from '@/assets/js/common.js'
export default {
    props: {},
    data() {
        return {
            detailDrawerHeader: {},
            detailDrawerTable: [],
            drawerTableLoading: false,
            barandArrearDrawerTable: [],
            drawerBarandArrearTableLoading: false,
            type: '',
            orderType: null, //CHD: 换货单 HHD: 还货单
            orderMeetType: false, // true品牌订货 false正常 B: 品牌订货 A: 商品订货
        }
    },
    methods: {
        drawerClose() {
            this.detailDrawerHeader = {}
            this.detailDrawerTable = []
            this.type = ''
            this.orderMeetType = false
        },
        // 获取单据详情事件
        async getDetailInfo(params) {
            this.drawerTableLoading = true
            this.type = params.billType
            const { data: res } = await this.$http.post('/Account/dataSearchVue/selectBillDetail.html', this.Qs.stringify(params))
            this.drawerTableLoading = false
            if (res.code != 'success') return this.$message.error(res.message)
            res.result = JSON.parse(res.result)
            const { headInfo, itemList: tableData } = JSON.parse(res.result.data)
            this.detailDrawerHeader = headInfo
            this.orderMeetType = headInfo.orderMeetType == 'B'
            console.log(headInfo)
            this.detailDrawerTable = tableData
        }
    }
}
</script>
<style scoped lang="less">
.detail_drawer_card {
    /deep/.el-card__body {
        padding: 10px 20px;
        height: 88px;
    }

    .el-row {
        margin-bottom: 10px;
    }

    .el-col {
        label {
            display: inline-block;
            width: 60px;
            text-align: right;
            margin-right: 6px;
        }
    }
}

.detail_drawer_table {
    flex: 1;
    // height: calc(100% - 98px);

    /deep/.el-table {
        td,
        th {
            padding: 6px 0;
        }

        .cell {
            padding: 0 6px;
        }
    }
}

.special_drawer {
    .detail_drawer_table {
        // height: calc(100% - 124px);
    }

    /deep/.el-card__body {
        height: 124px;
    }
}
</style>